import React from "react";
import NavigationItem from "./NavigationItem";
import MenuCallToActionButton from "../../common/components/MenuCallToActionButton";
import MobileBackButton from "../../common/components/MobileBackButton";
import useNavigationStack from "../../common/utils/useNavigationStack";
import AssortmentHighlightList from "./AssortmentHighlightList";
import { Link } from "../../../navigation";

const AssortmentLayout = ({ data, config, backToMainMenu }) => {
  const { highlights } = config || {};
  const { back, currentNavigation, callToAction } = useNavigationStack(
    data,
    backToMainMenu,
  );
  const normalizedCurrentRootUrl =
    currentNavigation?.url?.route || currentNavigation?.url;

  return (
    <div className="mkt-sub-nav full-width sortiment">
      <div className="container container-narrow">
        <MobileBackButton onClick={back} />
        <h3 className="ps-1 hide-on-not-mobile color-secondary regular-sans mt-4 mt-lg-0">
          <Link href={normalizedCurrentRootUrl}>
            {currentNavigation?.title}
          </Link>
        </h3>
        <div className="ps-1 row flex-column-reverse flex-lg-row">
          <div className="col-lg-4 col-xxl-3 navigation-list-column navigation-list-column--sortiment">
            {currentNavigation?.children.map(
              ({ url, data: { image }, title }, index) => {
                return (
                  <div key={`${title}-${url}-${index}`}>
                    <NavigationItem
                      className="navigation-list-item navigation-list-item--sortiment nav-hover d-inline-flex align-items-center gap-3"
                      link={url}
                      title={title}
                      image={image}
                      imageSize={{ width: 32, height: 32 }}
                    />{" "}
                  </div>
                );
              },
            )}
          </div>
          <div className="col-lg-8 col-xxl-9 mb-4 mb-lg-0">
            <AssortmentHighlightList highlights={highlights} />
          </div>
        </div>
        <MenuCallToActionButton callToAction={callToAction} />
      </div>
    </div>
  );
};

export default AssortmentLayout;
